import React, { useEffect, useReducer, createContext, Dispatch } from 'react';
import { KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN } from '../constant';
import { AuthAction, AuthState, AuthUser } from '../../interfaces/Contexts';
import { ReactChildren } from '../../interfaces/Common';
import storage from '../../storageService';



export const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  search: null,
};

const reducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'LOGIN':
      const userPayload = action.payload || { user: null };
      storage.set(KEY_REFRESH_TOKEN, userPayload.user?.refreshToken?.token ?? '');
      storage.set(KEY_ACCESS_TOKEN, userPayload.user?.accessToken?.token ?? '');
      storage.set('user', JSON.stringify(userPayload.user));
      // localStorage.setItem(KEY_REFRESH_TOKEN, userPayload.user?.refreshToken?.token ?? "");
      // localStorage.setItem(KEY_ACCESS_TOKEN, userPayload.user?.accessToken?.token ?? "");
      // localStorage.setItem("user", JSON.stringify(userPayload.user));
      return {
        ...state,
        isAuthenticated: userPayload.user && userPayload.user === null ? false : true,
        user: userPayload.user || null,
      };
    case 'LOGOUT':
      storage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        search: null,
      };
    default:
      return state;
  }
};

export const AuthContext = createContext<{
  state: AuthState;
  dispatch: Dispatch<AuthAction>;
}>({ state: initialState, dispatch: () => {} });

export const AuthContextProvider: React.FunctionComponent<ReactChildren> = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = await storage.get('user');
        if (user) {
          console.log('user', user);

          const parsedUser: AuthUser = JSON.parse(user);
          console.log('json', parsedUser);
          dispatch({
            type: 'LOGIN',
            payload: {
              user: parsedUser,
            },
          });
        }
      } catch (error) {
        console.error('Failed to fetch user data', error);
      }
    };

    fetchUserData();
  }, [dispatch]);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
